import React, { useCallback, useEffect, useMemo, useState } from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import TableContainer from 'Common/TableContainer';
import Select from "react-select";
// Icons
import { Search, Plus, Download, SlidersHorizontal, Trash2, Eye, Pencil, } from 'lucide-react';
import Modal from 'Common/Components/Modal';
import { Link } from 'react-router-dom';
// react-redux
import { useDispatch, useSelector } from 'react-redux';

import { createSales, getSale, createShipment, patchDeliveryEntry } from "slices/settings/thunk";
import { getManager, getShipment } from 'slices/thunk';
import { RootState } from 'slices';
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import { ToastContainer } from 'react-toastify';

const AddShipment = () => {
    const dispatch = useDispatch<any>();
    const manager = useSelector((state: RootState) => state.Ecommerce.Manager) as any[]
    const shipment = useSelector((state: RootState) => state.Ecommerce.shipment);

    useEffect(() => {
        dispatch(getManager('') as any)
        dispatch(getShipment() as any)
    }, [dispatch])

    console.log("shipment:", shipment)

    const managersOnly = useMemo(() => {
        if (Array.isArray(manager) && manager.length > 0) {
            return manager.map((item: any) => ({
                id: item.manager?._id || item._id,
                username: item.manager?.username || item.username,
            })).filter(item => item.id && item.username);
        }
        return [];
    }, [manager]);


    const [eventData, setEventData] = useState<any>(null);
    const [show, setShow] = useState<boolean>(false);
    const [showEdit, setShowEdit] = useState<boolean>(false);
    const [editData, setEditData] = useState<any>(null);
    const [isEdit, setIsEdit] = useState<boolean>(false);

    const validation: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            shipperName: (eventData && eventData.shipperName) || '',
            receiverId: (eventData && eventData.receiverId) || '',
            transferCharge: (eventData && eventData.transferCharge) || '',
            weight: (eventData && eventData.weight) || '',
            // totalvalue: (eventData && eventData.totalvalue) || '',
            delivery: (eventData && eventData.delivery) || '',
            currentLocation: (eventData && eventData.currentLocation) || '',
            destination: (eventData && eventData.destination) || '',
            managerId: (eventData && eventData.managerId) || '',
        },
        validationSchema: Yup.object({
            shipperName: Yup.string().required("Please Enter Shipper Name"),
            transferCharge: Yup.number().optional(),
            weight: Yup.number().optional(),
            // totalvalue: Yup.number().required("Please Enter Total Value"),
            currentLocation: Yup.string().required("Please Enter Current Location"),
            destination: Yup.string().required("Please Enter Destination"),
            managerId: Yup.string().required("Please select a manager"),
            receiverId: Yup.string().required("Please select a receiver"),
            delivery: Yup.date().required("Please select a delivery time"),
        }),
        onSubmit: (values) => {
            console.log('Form values:', values);
            const newShipment = {
                ...values,
            };
            console.log(newShipment)
            dispatch(createShipment(newShipment)).then(() => {
                dispatch(getShipment() as any)
                toggle();
            });

        },
    });


    const editValidation: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            shipmentId: (editData && editData._id) || '',
            receiverName: (editData && editData.receiverName) || '',
            transferCharge: (editData && editData.transferCharge) || '',
        },
        validationSchema: Yup.object({
            receiverName: Yup.string().required("Please Enter Receiver Name"),
            transferCharge: Yup.number().required("Please Enter Transfer Charge"),
        }),
        onSubmit: (values) => {
            console.log('Edit form values:', values);
            const updatedShipment = {
                shipment_id: values.shipmentId,
            }
            dispatch(patchDeliveryEntry(updatedShipment)).then(() => {
                dispatch(getShipment() as any)
                toggleEdit();
            })

        },
    });

    const toggle = useCallback(() => {
        if (show) {
            setShow(false);
            setEventData(null);
        } else {
            setShow(true);
            setEventData(null);
            validation.resetForm();
        }
    }, [show, validation]);

    const toggleEdit = useCallback(() => {
        if (showEdit) {
            setShowEdit(false);
            setEditData(null);
        } else {
            setShowEdit(true);
            editValidation.resetForm();
        }
    }, [showEdit, editValidation]);

    const handleEdit = useCallback((data: any) => {
        setEditData(data);
        setIsEdit(true);
        setShowEdit(true);
    }, []);

    const Status = ({ item }: any) => {
        switch (item) {
            case "recieved":
                return (<span className="delivery_status px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-green-100 border-green-200 text-green-500 dark:bg-green-500/20 dark:border-green-500/20">received</span>);
            case "pending":
                return (<span className="delivery_status px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-yellow-100 border-yellow-200 text-yellow-500 dark:bg-yellow-500/20 dark:border-yellow-500/20">{item}</span>);
            case "cancelled":
                return (<span className="delivery_status px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-red-100 border-red-200 text-red-500 dark:bg-red-500/20 dark:border-red-500/20">{item}</span>);
            default:
                return (<span className="delivery_status px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-gray-100 border-gray-200 text-gray-500 dark:bg-gray-500/20 dark:border-gray-500/20">{item}</span>);
        }
    };

    const columns = useMemo(() => [
        {
            header: "Delivery",
            accessorFn: (row: any) => row.delivery ?? "N/A",
            enableColumnFilter: false,
            cell: (info: any) => {
                const value = info.getValue();
                if (value === "N/A" || !value) return "N/A";
                try {
                    return new Date(value).toLocaleString("en-US", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                    });
                } catch (error) {
                    return "Invalid Date";
                }
            },
        },
        {
            header: "Shipper Name",
            accessorFn: (row: any) => row.shipperName ?? "N/A",
            enableColumnFilter: false,
        },
        {
            header: "Receiver Name",
            accessorFn: (row: any) => row.receiverName ?? "N/A",
            enableColumnFilter: false
        },
        {
            header: "Destination",
            accessorFn: (row: any) => row.destination ?? "N/A",
            enableColumnFilter: false
        },

        {
            header: "Transfer Charge",
            accessorFn: (row: any) => row.transferCharge ?? "N/A",
            enableColumnFilter: false
        },
        {
            header: "Status",
            accessorFn: (row: any) => row.status ?? "N/A",
            enableColumnFilter: false,
            cell: (cell: any) => (
                <Status item={cell.getValue()} />
            ),
        },
        {
            header: "Current Location",
            accessorFn: (row: any) => row.currentLocation ?? "N/A",
            enableColumnFilter: false
        },
        {
            header: "Action",
            enableColumnFilter: false,
            enableSorting: false,
            cell: (cell: any) => {
                const rowData = cell.row.original;
                const isReceived = rowData.status?.toLowerCase() === "recieved";

                return (
                    <div className="flex gap-3">
                        {!isReceived && (
                            <button
                                className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md edit-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                                onClick={() => handleEdit(rowData)}
                            >
                                <Pencil className="size-4" />
                            </button>
                        )}
                    </div>
                );
            },
        }

    ], [handleEdit]);

    return (
        <React.Fragment>
            <div className='container-fluid group-data-[content=boxed]:max-w-boxed mx-auto'>
                <BreadCrumb title='Add Shipment' pageTitle='Dashboards' />
                <ToastContainer closeButton={false} limit={1} />
                <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12">
                    <div className="xl:col-span-12">
                        <div className="card" id="usersTable">
                            <div className="card-body">
                                <div className="flex items-center justify-end">
                                    <div className="shrink-0">
                                        <button type="button" className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20" onClick={toggle}><Plus className="inline-block size-4" /> <span className="align-middle">Add Shipment</span></button>
                                    </div>
                                </div>
                            </div>
                            <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
                                <form action="#!">
                                    <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                                        <div className="xl:col-span-3 xl:col-start-10">
                                            <div className="flex gap-2 xl:justify-end">
                                                <div>
                                                    <button type="button" className="bg-white border-dashed text-custom-500 btn border-custom-500 hover:text-custom-500 hover:bg-custom-50 hover:border-custom-600 focus:text-custom-600 focus:bg-custom-50 focus:border-custom-600 active:text-custom-600 active:bg-custom-50 active:border-custom-600 dark:bg-zink-700 dark:ring-custom-400/20 dark:hover:bg-custom-800/20 dark:focus:bg-custom-800/20 dark:active:bg-custom-800/20"><Download className="inline-block size-4" /> <span className="align-middle">Import</span></button>
                                                </div>
                                                <button type="button" className="flex items-center justify-center size-[37.5px] p-0 text-slate-500 btn bg-slate-100 hover:text-white hover:bg-slate-600 focus:text-white focus:bg-slate-600 focus:ring focus:ring-slate-100 active:text-white active:bg-slate-600 active:ring active:ring-slate-100 dark:bg-slate-500/20 dark:text-slate-400 dark:hover:bg-slate-500 dark:hover:text-white dark:focus:bg-slate-500 dark:focus:text-white dark:active:bg-slate-500 dark:active:text-white dark:ring-slate-400/20"><SlidersHorizontal className="size-4" /></button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="card-body">
                                {Array.isArray(shipment) && shipment.length > 0 ?
                                    <TableContainer
                                        isPagination={true}
                                        columns={(columns || [])}
                                        data={(shipment || [])}
                                        customPageSize={7}
                                        divclassName="-mx-5 -mb-5 overflow-x-auto"
                                        tableclassName="w-full border-separate table-custom border-spacing-y-1 whitespace-nowrap"
                                        theadclassName="text-left relative rounded-md bg-slate-100 dark:bg-zink-600 after:absolute ltr:after:border-l-2 rtl:after:border-r-2 ltr:after:left-0 rtl:after:right-0 after:top-0 after:bottom-0 after:border-transparent [&.active]:after:border-custom-500 [&.active]:bg-slate-100 dark:[&.active]:bg-zink-600"
                                        thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold"
                                        tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5"
                                        PaginationClassName="flex flex-col items-center mt-8 md:flex-row"
                                    />
                                    :
                                    (<div className="noresult">
                                        <div className="py-6 text-center">
                                            <Search className="size-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" />
                                            <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
                                            <p className="mb-0 text-slate-500 dark:text-zink-200">We've searched more than 199+ shipments. We did not find any shipments for your search.</p>
                                        </div>
                                    </div>)}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Add Shipment Modal */}
                <Modal show={show} onHide={toggle} id="addShipmentModal" modal-center="true"
                    className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
                    dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600">
                    <Modal.Header className="flex items-center justify-between p-4 border-b dark:border-zink-300/20"
                        closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500">
                        <Modal.Title className="text-16">Add Shipment</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
                        <form action="#!" onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}>
                            <div className="mb-3">
                                <label htmlFor="shipperName" className="inline-block mb-2 text-base font-medium">Shipper Name</label>
                                <input type="text" id="shipperName" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Enter Shipper Name"
                                    name="shipperName"
                                    onChange={validation.handleChange}
                                    value={validation.values.shipperName || ""}
                                />
                                {validation.touched.shipperName && validation.errors.shipperName ? (
                                    <p className="text-red-400">{validation.errors.shipperName}</p>
                                ) : null}
                            </div>

                            <div className="mb-3">
                                <label htmlFor="managerId" className="inline-block mb-2 text-base font-medium">
                                    Manager
                                </label>
                                <Select
                                    inputId="managerId"
                                    name="managerId"
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    options={managersOnly.map((m) => ({
                                        label: m.username,
                                        value: m.id,
                                        isDisabled: validation.values.receiverId === m.id
                                    }))}
                                    value={managersOnly
                                        .map((m) => ({
                                            label: m.username,
                                            value: m.id,
                                            isDisabled: validation.values.receiverId === m.id
                                        }))
                                        .find((option) => option.value === validation.values.managerId) || null
                                    }
                                    onChange={(selectedOption) => {
                                        validation.setFieldValue("managerId", selectedOption?.value || "");
                                    }}
                                    placeholder="Select Manager"
                                    isClearable
                                />

                                {validation.touched.managerId && validation.errors.managerId ? (
                                    <p className="text-red-400">{validation.errors.managerId}</p>
                                ) : null}
                            </div>

                            <div className="mb-3">
                                <label htmlFor="receiverId" className="inline-block mb-2 text-base font-medium">
                                    Receiving Manager
                                </label>
                                <Select
                                    inputId="receiverId"
                                    name="receiverId"
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    options={managersOnly.map((m) => ({
                                        label: m.username,
                                        value: m.id,
                                        isDisabled: validation.values.managerId === m.id
                                    }))}
                                    value={managersOnly
                                        .map((m) => ({
                                            label: m.username,
                                            value: m.id,
                                            isDisabled: validation.values.managerId === m.id
                                        }))
                                        .find((option) => option.value === validation.values.receiverId) || null
                                    }
                                    onChange={(selectedOption) => {
                                        validation.setFieldValue("receiverId", selectedOption?.value || "");
                                    }}
                                    placeholder="Select Manager"
                                    isClearable
                                />

                                {validation.touched.receiverId && validation.errors.receiverId ? (
                                    <p className="text-red-400">{validation.errors.receiverId}</p>
                                ) : null}
                            </div>


                            <div className="mb-3">
                                <label htmlFor="transferCharge" className="inline-block mb-2 text-base font-medium">Transfer Charge</label>
                                <input type="number" id="transferCharge" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Enter Transfer Charge"
                                    name="transferCharge"
                                    onChange={validation.handleChange}
                                    value={validation.values.transferCharge || ""}
                                />
                                {validation.touched.transferCharge && validation.errors.transferCharge ? (
                                    <p className="text-red-400">{validation.errors.transferCharge}</p>
                                ) : null}
                            </div>

                            <div className="mb-3">
                                <label htmlFor="weight" className="inline-block mb-2 text-base font-medium">Weight</label>
                                <input type="number" id="weight" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Enter weight"
                                    name="weight"
                                    onChange={validation.handleChange}
                                    value={validation.values.weight || ""}
                                />
                                {validation.touched.weight && validation.errors.weight ? (
                                    <p className="text-red-400">{validation.errors.weight}</p>
                                ) : null}
                            </div>
                            <div className="mb-3">
                                <label htmlFor="delivery" className="inline-block mb-2 text-base font-medium">Delivery Time</label>
                                <input type="datetime-local" id="delivery" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                    name="delivery"
                                    onChange={validation.handleChange}
                                    value={validation.values.delivery || ""}
                                />
                                {validation.touched.delivery && validation.errors.delivery ? (
                                    <p className="text-red-400">{validation.errors.delivery}</p>
                                ) : null}
                            </div>
                            <div className="mb-3">
                                <label htmlFor="currentLocation" className="inline-block mb-2 text-base font-medium">Current Location</label>
                                <select
                                    id="currentLocation"
                                    name="currentLocation"
                                    className="form-select border-slate-200 dark:border-zink-500 dark:bg-zink-700 dark:text-zink-100"
                                    onChange={validation.handleChange}
                                    value={validation.values.currentLocation || ""}
                                >
                                    <option value="">Select Country</option>
                                    <option value="dubai">Dubai</option>
                                    <option value="saudi">Saudi</option>
                                    <option value="jeddah">Jeddah</option>
                                    <option value="dammam">Dammam</option>
                                    <option value="riyadh">Riyadh</option>
                                    <option value="qatar">Qatar</option>
                                </select>
                                {validation.touched.currentLocation && validation.errors.currentLocation ? (
                                    <p className="text-red-400">{validation.errors.currentLocation}</p>
                                ) : null}
                            </div>

                            <div className="mb-3">
                                <label htmlFor="destination" className="inline-block mb-2 text-base font-medium">Destination</label>
                                <select
                                    id="destination"
                                    name="destination"
                                    className="form-select border-slate-200 dark:border-zink-500 dark:bg-zink-700 dark:text-zink-100"
                                    onChange={validation.handleChange}
                                    value={validation.values.destination || ""}
                                >
                                    <option value="">Select Destination</option>
                                    <option value="dubai">Dubai</option>
                                    <option value="saudi">Saudi</option>
                                    <option value="jeddah">Jeddah</option>
                                    <option value="dammam">Dammam</option>
                                    <option value="riyadh">Riyadh</option>
                                    <option value="qatar">Qatar</option>
                                </select>
                                {validation.touched.destination && validation.errors.destination ? (
                                    <p className="text-red-400">{validation.errors.destination}</p>
                                ) : null}
                            </div>

                            {/* <div className="mb-3">
                                <label htmlFor="totalvalue" className="inline-block mb-2 text-base font-medium">Total Value</label>
                                <input type="number" id="totalvalue" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Enter Total Value"
                                    name="totalvalue"
                                    onChange={validation.handleChange}
                                    value={validation.values.totalvalue || ""}
                                />
                                {validation.touched.totalvalue && validation.errors.totalvalue ? (
                                    <p className="text-red-400">{validation.errors.totalvalue}</p>
                                ) : null}
                            </div> */}

                            <div className="flex justify-end gap-2 mt-4">
                                <button type="button" className="text-red-500 transition-all duration-200 ease-linear bg-white border-white btn hover:text-red-600 focus:text-red-600 active:text-red-600 dark:bg-zink-500 dark:border-zink-500" onClick={toggle}>Cancel</button>
                                <button type="submit" className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                                    Add Shipment
                                </button>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
                {/* Edit Shipment Modal */}
                <Modal show={showEdit} onHide={toggleEdit} id="editShipmentModal" modal-center="true"
                    className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
                    dialogClassName="w-screen md:w-[25rem] bg-white shadow rounded-md dark:bg-zink-600">
                    <Modal.Header className="flex items-center justify-between p-4 border-b dark:border-zink-300/20"
                        closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500">
                        <Modal.Title className="text-16">Edit Shipment</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
                        <form action="#!" onSubmit={(e) => {
                            e.preventDefault();
                            editValidation.handleSubmit();
                            return false;
                        }}>

                            <div className="mb-3">
                                <label htmlFor="editReceiverName" className="inline-block mb-2 text-base font-medium">Receiver Name</label>
                                <input
                                    type="text"
                                    id="editReceiverName"
                                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                    placeholder="Enter Receiver Name"
                                    name="receiverName"
                                    onChange={editValidation.handleChange}
                                    value={editValidation.values.receiverName || ""}
                                    disabled
                                />
                                {editValidation.touched.receiverName && editValidation.errors.receiverName ? (
                                    <p className="text-red-400">{editValidation.errors.receiverName}</p>
                                ) : null}
                            </div>

                            <div className="mb-3">
                                <label htmlFor="editTransferCharge" className="inline-block mb-2 text-base font-medium">Transfer Charge (Amount)</label>
                                <input
                                    type="number"
                                    id="editTransferCharge"
                                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                    placeholder="Enter Transfer Charge"
                                    name="transferCharge"
                                    onChange={editValidation.handleChange}
                                    value={editValidation.values.transferCharge || ""}
                                />
                                {editValidation.touched.transferCharge && editValidation.errors.transferCharge ? (
                                    <p className="text-red-400">{editValidation.errors.transferCharge}</p>
                                ) : null}
                            </div>

                            <div className="flex justify-end gap-2 mt-4">
                                <button
                                    type="button"
                                    className="text-red-500 transition-all duration-200 ease-linear bg-white border-white btn hover:text-red-600 focus:text-red-600 active:text-red-600 dark:bg-zink-500 dark:border-zink-500"
                                    onClick={toggleEdit}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                                >
                                    Update Shipment
                                </button>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            </div>
        </React.Fragment>
    );
};

export default AddShipment;